module.exports = __webpack_public_path__ + "static/1-da20c87523ea5e36965f6ebdf8fefdfc.png";